<template>
  <CHeader with-subheader class="py-2 px-3 bg-white shadow-sm">
    <!-- Sidebar toggles -->
    <div class="d-flex align-items-center">
      <CToggler in-header class="d-lg-none mr-2" @click="$store.commit('toggleSidebarMobile')" />
      <CToggler in-header class="d-none d-lg-inline mr-3" @click="$store.commit('toggleSidebarDesktop')" />
    </div>

    <!-- User info -->
    <CHeaderNav class="mr-auto d-flex align-items-center">
      <div class="c-avatar mr-2">
        <img src="img/avatars/user.png" class="c-avatar-img" />
      </div>
      <div class="d-flex flex-column text-truncate">
        <span class="small fw-semibold text-secondary">{{ user_login?.nama || user_login?.email }}</span>
        <span class="text-muted" style="font-size: 11px">{{ user_role?.namaRole || "-" }}</span>
      </div>
    </CHeaderNav>

    <!-- Right section -->
    <CHeaderNav class="d-flex align-items-center flex-wrap justify-content-end gap-2 text-nowrap">
      <!-- Language Toggle -->
      <CHeaderNavItem class="px-1">
        <button @click="$store.commit('set_lang', $store.state.lang === 'id' ? 'en' : 'id')" class="btn btn-sm btn-light border-0">
          {{ $store.state.lang === "id" ? "en" : "id" }}
        </button>
      </CHeaderNavItem>

      <!-- Calendar + Clock -->
      <div class="d-flex align-items-center text-muted small">
        <CIcon name="cil-calendar" class="mr-1" />
        <span class="mr-2"> {{ countdown.day || moment().format("dddd") }}, {{ countdown.date || moment().format("DD MMMM") }} </span>
        <CIcon name="cil-clock" class="mr-1" />
        <span>{{ countdown.hour || moment().format("HH") }}.{{ countdown.minute || moment().format("mm") }} {{ moment().format("A") }}</span>
      </div>

      <!-- Notification -->
      <CIcon name="cil-bell" class="ml-2 text-secondary" />

      <!-- Account dropdown -->
      <TheHeaderDropdownAccnt />

      <!-- Mitra Info -->
      <div class="ml-3 d-none d-sm-block">
        <span class="text-muted small">{{ mitra?.namaMitra }}</span>
      </div>
    </CHeaderNav>
  </CHeader>
</template>

<script>
// import axios from "axios";
// import { ipBackend } from "@/ipBackend";
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
import moment from "moment";

export default {
  name: "TheHeader",
  components: {
    TheHeaderDropdownAccnt,
  },
  data() {
    return {
      moment,
      itemsCount: 0,
      countdown: {
        day: null,
        date: null,
        hour: null,
        minute: null,
      },
      interval: null,
    };
  },
  created() {
    this.setTimer();
    this.get_aktif_mitra();
    // this.getNotif();
    // this.hitung(15)
  },
  computed: {
    user_login() {
      return this.$store.state.login_data_user ? this.$store.state.login_data_user : null;
    },
    user_role() {
      return this.$store.state.role_aktif ? this.$store.state.role_aktif : null;
    },
    mitra() {
      return this.$store.state.mitra_aktif ? this.$store.state.mitra_aktif : null;
    },
  },
  methods: {
    setTimer() {
      const intervals = setInterval(() => {
        const now = this.moment();
        this.countdown.hour = now.format("HH");
        this.countdown.minute = now.format("mm");
        this.countdown.day = now.format("dddd");
        this.countdown.date = now.format("DD MMMM");
      }, 1000);
      this.interval = intervals;
      clearInterval(this.interval - 1);
    },
    getNotif() {
      let vm = this;
      vm.$axios
        .get("OP/listByStatusOP/0")
        .then((res) => {
          console.log(res);
          this.itemsCount = res.data.data.length;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    get_aktif_mitra() {
      let vm = this;
      vm.$axios
        .post("mitra/listPerHalaman", {
          jumlah: 1,
          halaman: "0",
        })
        .then((res) => {
          console.log(res);
          vm.$store.commit("set_mitra", res.data.data[0]);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.c-avatar {
  width: 36px;
  height: 36px;
}
@media (max-width: 576px) {
  .c-avatar {
    width: 28px;
    height: 28px;
  }
  .c-header {
    padding: 0.25rem 0.5rem !important;
  }
  .text-muted.small {
    font-size: 11px;
  }
}
</style>
